import React, { useContext, useEffect, useState, createRef } from 'react';
import { cn } from '@bem-react/classname';
import { IMaskInput } from 'react-imask';
import { inject, observer } from "mobx-react";
import ym from 'react-yandex-metrika';
import { RegContext } from "../RegContext";
import { browser, transformPhoneNumber } from "../../../../common";
import './style.scss';
import {
  logForLostFocusPhone,
} from "../../../../logger/loggerRegForm";

if (browser().safari) {
  import('smoothscroll-polyfill').then((s) => s.polyfill())
}

const PhoneSelect = inject('appStore', 'kafkaStore')(observer((props) => {
  const {
    kafkaStore: {
      imprintHash
    },
    selectedCountry,
    onSelect,
    onInput,
    data,
    label,
    errorMessage,
    value,
    searchInputPlaceholder,
    defaultCountryId,
    time,
    counter,
    setTime,
    listCounter
  } = props;

  const {
    isCountryListOpen,
    setIsCountryListOpen,
    isCurrencyListOpen,
    setIsCurrencyListOpen
  } = useContext(RegContext);

  const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
  const countryListRef = createRef();
  const searchInputRef = createRef();
  const [countryList, setCountryList] = useState([])
  const [inputMask, setInputMask] = useState(/[+\(\)0-9-]/);
  const selectCn = cn('PhoneCode');

  const smoothScroll = ref => {
    ref.current.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
      autoKill: false
    });
  };

  const onSelectCountry = (item) => {
    onSelect(item);
  };

  const clickSelect = (visible) => {
    if (isCurrencyListOpen) {
      setIsCurrencyListOpen(false);
    }
    setIsCountryListOpen(visible);
    counter();
  };

  const listHandler = (e) => {
    onSelectCountry(countryList[e.currentTarget.getAttribute('data-index')]);
    setIsCountryListOpen(false);
    counter();
  };

  const search = (filterString, arr, objectKey) => {
    filterString = filterString.toLowerCase();
    if (objectKey === 'phone_code' && filterString.indexOf('+') === -1) {
      filterString = `+${filterString}`
    }
    return arr
      .filter(item => item[objectKey].toLowerCase().includes(filterString))
      .sort((a, b) => {
        const aStarts = a[objectKey].toLowerCase().startsWith(filterString);
        const bStarts = b[objectKey].toLowerCase().startsWith(filterString);
        if (aStarts && bStarts) return a[objectKey].localeCompare(b[objectKey]);
        if (aStarts && !bStarts) return -1;
        if (!aStarts && bStarts) return 1;
        return a[objectKey].localeCompare(b[objectKey]);
      });
  };

  const handleSearch = (e) => {
    if (e.target.value) {
      const searchedValue = e.target.value.toLowerCase();
      const isPhoneCode = /^[+0-9]/.test(e.target.value);
      let newCountryList;

      if (!isPhoneCode) {
        newCountryList = search(searchedValue, sortedData, 'name');
      } else {
        const result = search(searchedValue, sortedData, 'phone_code');
        newCountryList = result.sort((a, b) => a.phone_code.length - b.phone_code.length);
      }
      setCountryList(newCountryList);
    }
  }

  const inputMaskRU = `${selectedCountry.phone_code}(000)000-00-00`;
  // const inputMaskBR = /^[+][5]{2}\(\d{3}\)\d{3}-\d{2}-\d{2,3}/;
  // const inputMaskBR = /^[+\(\)55-]/
  // const inputMaskBR = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/
  const inputMaskBR = `${selectedCountry.phone_code}(000)000-00-00${'0' || ''}`

  const renderItem = (item, index) => (
    <li key={index + 1} className={selectCn('Item')} data-index={index} onClick={((e) => listHandler(e))}>
      <span className={selectCn('SelectIcon f32')}>
        <span className={`${selectCn('SelectFlag flag')} ${item.code.toLowerCase()}`} />
      </span>
      <span className={selectCn('SelectLabel')}>{item.code}</span>
      <span className={selectCn('ItemCountryName')}>
        {item.name}
      </span>
      <span className={selectCn('ItemCountryCode')}>
        {item.phone_code}
      </span>
    </li>
  )

  const logBlurInput = (value, imprint) => {
    value = transformPhoneNumber(value);
    logForLostFocusPhone(value, imprint)
  }

  const onBlurInput = () => {
    logBlurInput(value, imprintHash);
    ym('reachGoal','regType')
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (listCounter === 1) {
        setTime(prevState => prevState + 1)
      }

    }, 1000);
    return () => {
      clearInterval(interval)
    }
  }, [listCounter])

  useEffect(() => {
    setCountryList(sortedData)
  }, []);

  useEffect(() => {
    if (selectedCountry.country_id === 76) {
      setInputMask(inputMaskBR);
    } else {
      setInputMask(inputMaskRU);
    }
  }, [selectedCountry]);

  useEffect(() => {
    isCurrencyListOpen && setIsCountryListOpen(false);
  }, [isCurrencyListOpen]);

  useEffect(() => {
    if (!isCountryListOpen) {
      searchInputRef.current.value = '';
      setCountryList(sortedData);
      smoothScroll(countryListRef);
    }
  }, [isCountryListOpen]);

  return (
    <div className={`${selectCn('InputWrapper Input-Wrapper')} ${errorMessage ? 'error' : null}`}>
      <div className={selectCn('LabelWrapper InputLabel-Wrapper')}>
        <span className={selectCn('Label Input-Label')}>{label}</span>
      </div>
      <div className={selectCn('Inner Input-Inner', { visible: isCountryListOpen })}>
        <div className={selectCn('Select')} onClick={() => clickSelect(!isCountryListOpen)}>
          <span className={selectCn('SelectIcon f32')}>
            <span
              className={`${selectCn('SelectFlag flag')} ${selectedCountry.code.toLowerCase()}`} />
          </span>
          <span className={selectCn('SelectLabel')}>{selectedCountry.code}</span>
          <span className={selectCn('Arrow')} />
        </div>
        <IMaskInput onBlur={onBlurInput}
          className={selectCn('Input Input')}
          mask={inputMask}
          radix='.'
          value={value}
          // unmask={true}
          onAccept={onInput}
          placeholder={label}
        />
        <ul ref={countryListRef} className={selectCn('List')}>
          <input
            ref={searchInputRef}
            placeholder={searchInputPlaceholder}
            className={selectCn('Search Search')}
            onInput={handleSearch}
            autoComplete="off"
          />
          {countryList.map((item, index) => renderItem(item, index))}
        </ul>
      </div>
      {errorMessage && <span className={selectCn('InputError Input-Error')}>{errorMessage}</span>}
    </div>
  );
}));

export default PhoneSelect;
